var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseButton',{staticClass:"w-10 h-10 p-1 mx-1 shadow-md bg-warmGray-100 \\\n\t\tmd:p-2 md:mx-2 md:w-12 md:h-12 \\\n\t\thover:bg-pink-700 hover:text-white \\\n\t\tfocus:border-pink-800 \\\n\t\tdark:bg-trueGray-800 dark:hover:bg-pink-700",attrs:{"icon":_vm.icon,"message":_vm.message},on:{"button-clicked":function () { return this$1.$emit(_vm.eventName); }}})}
var staticRenderFns = []

export { render, staticRenderFns }